// extracted by mini-css-extract-plugin
export default {"title":"UpdateEmployerModal_title__Zh79u","Modal":"UpdateEmployerModal_Modal__JPGy0","Overlay":"UpdateEmployerModal_Overlay__z+P2f"};